import React from 'react';
import Btn, { BtnModifier } from '../Btn';
import IUrl from '../../../types/IUrl';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum FooterLinkModifier {
  PADDING_BOTTOM = 'padding-bottom',
}

type FooterLinkProps = {
  footerButtonLabel: string;
  footerLink?: IUrl;
  modifier?: Modifier<FooterLinkModifier>;
};

export function FooterLink({ footerButtonLabel, footerLink, modifier }: FooterLinkProps) {
  if (footerLink?.url) {
    return (
      <div className={bem('footer-link', modifier)}>
        <Btn modifier={BtnModifier.SINGLE_ACTION} text={footerButtonLabel} href={footerLink.url} />
      </div>
    );
  }
  return null;
}
